import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/index",
  },
  {
    path: '/index',
    component: () => import('../views/index/index.vue'),
    meta: {
      name: "首页",
      title: "Home",
    },
  },
  {
    path: "/businessScope",
    component: () => import("../views/businessScope/index.vue"),
    meta: {
      name: "产品中心-业务范围",
      title: "Business Scope",
    },
  },
  {
    path: "/productCenter",
    component: () => import("../views/productCenter/index.vue"),
    meta: {
      name: "产品中心",
      title: "Product Center",
    },
  },
  {
    path: "/smartHomeDigitalHuman",
    component: () => import("../views/smartHomeDigitalHuman/index.vue"),
    meta: {
      name: "产品中心",
      title: "Product Center",
    },
  },
  {
    path: "/mobileDigitalHuman",
    component: () => import("../views/mobileDigitalHuman/index.vue"),
    meta: {
      name: "产品中心-移动数字人",
      title: "Product Center",
    },
  },
  {
    path: "/contactUs",
    component: () => import("../views/contactUs/index.vue"),
    meta: {
      name: "产品中心-联系我们",
      title: "Contact Us",
    },
  },
  {
    path: "/aboutUs",
    component: () => import("../views/aboutUs/index.vue"),
    meta: {
      name: "产品中心-关于我们",
      title: "About Us",
    },
  },
  // 详情页
  {
    path: "/learnMoreDs",
    component: () => import("../views/learnMoreDs/index.vue"),
    meta: {
      name: "产品中心-详情1",
      title: "",
    },
  },
  {
    path: "/businessScopeDs",
    component: () => import("../views/businessScopeDs/index.vue"),
    meta: {
      name: "产品中心-详情2",
      title: "",
    },
  },




  {
		path: "/pageNotFound",
		name: "pageNotFound",
		component: () => import("../views/page-not-found/pagenotfound.vue"),
	},
	{
		path: "*",
		redirect: "/pageNotFound",
		name: "notFound",
		hidden: true,
	},
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0,
			};
		}
	},
})

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error);
};

export default router